import React from "react";
import PropTypes from "prop-types";
import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import CycleDialog, { CycleFields } from "../../creacionCiclo/components/CycleDialog";
import {
  displayAccesparkDate,
  displayAccesparkCreatedAt,
  isOpeningCycle,
} from "../model/accesparkModel";
export default function AccesparkDetailDialog({ cycle, onClose }) {
  return (
    <CycleDialog
      open={Boolean(cycle)}
      onClose={onClose}
      title={`Intento ${[4, 5].includes(Number(cycle?.cycle_type)) ? "Ezytec" : "Accespark"} #${
        cycle?.id ?? ""
      }`}
      subtitle={
        isOpeningCycle(cycle?.cycle_type) ? "Historial de aperturas" : "Historial de cierres"
      }
      actions={
        <Button variant="outlined" onClick={onClose}>
          Cerrar detalle
        </Button>
      }
    >
      {cycle && (
        <>
          <Alert
            severity={cycle.result.severity}
            sx={{ borderRadius: 2, "& .MuiAlert-message": { width: "100%", minWidth: 0 } }}
          >
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "inherit" }}>
                {cycle.result.label}
              </Typography>
              {cycle.result.code !== null && (
                <Chip
                  size="small"
                  label={`Código ${cycle.result.code}`}
                  sx={{ bgcolor: "rgba(255,255,255,.65)", color: "inherit" }}
                />
              )}
            </Box>
            <Typography
              sx={{ fontSize: ".82rem", mt: 0.75, color: "inherit", overflowWrap: "anywhere" }}
            >
              {cycle.result.message}
            </Typography>
          </Alert>
          <CycleFields
            title="DATOS DE LA OPERACIÓN"
            fields={[
              ["Comercio", cycle.metadata?.commerce],
              ["Placa", cycle.metadata?.plate],
              [
                isOpeningCycle(cycle.cycle_type)
                  ? "Fecha de entrada · Colombia"
                  : "Fecha de salida · Colombia",
                displayAccesparkDate(cycle.eventAt),
              ],
              ["Registro de solicitud · Colombia", displayAccesparkCreatedAt(cycle.createdAt)],
            ]}
          />
          <CycleFields
            title="ORIGEN DE LA SOLICITUD"
            fields={[
              ["ID de terminal", cycle.metadata?.idterminal ?? cycle.payload?.idterminal],
              ["ID del usuario", cycle.metadata?.userId ?? cycle.user_id],
              ["Dirección IP", cycle.ip],
              ["Tipo de historial", isOpeningCycle(cycle.cycle_type) ? "Apertura" : "Cierre"],
            ]}
          />
          <Box
            component="details"
            sx={{ border: "1px solid #dce5ed", borderRadius: 2, bgcolor: "#fff" }}
          >
            <Typography
              component="summary"
              sx={{ p: 2, fontSize: ".8rem", cursor: "pointer", color: "#526579" }}
            >
              Datos técnicos originales
            </Typography>
            <Box
              component="pre"
              sx={{ m: 0, p: 2, fontSize: ".72rem", overflow: "auto", maxHeight: 240 }}
            >
              {JSON.stringify({ ...cycle, eventAt: undefined, result: undefined }, null, 2)}
            </Box>
          </Box>
        </>
      )}
    </CycleDialog>
  );
}
AccesparkDetailDialog.propTypes = { cycle: PropTypes.object, onClose: PropTypes.func.isRequired };
AccesparkDetailDialog.defaultProps = { cycle: null };
